import { IDevices } from '../../interfaces';

export const devices: Record<string | number, IDevices> = {
    '5903': {
        nombre: 'ABCD016',
        patente: 'ABCD016',
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=camion3.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=camion3.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: '12751',
        codigo_erp: '',
        agrupacion: 'TIPO PRODUCTO D',
        id_dispositivo: '5903',
        telefono: '',
        chofer: '10696',
        expiracion_token: null,
        utilizacion_token: null,
        nombre_chofer: 'José Mendez',
        rateId: null,
        zonas: [
            '271417',
            '280939',
            '766563',
            '768769',
            '857185',
            '857186',
            '857189',
            '566401977',
            '566401981',
            '566401983',
            '566401987',
        ],
        cortes: {
            Peso: {
                id_maquina: '5903',
                valor: 10000,
                nombre: 'Peso',
                url_icono: 'balanza2.png',
                unidad: 'Kilogramos',
                prefijo: '',
                sufijo: 'kg',
                carga: 0,
                nombreOriginal: 'Peso',
            },
            Volumen: {
                id_maquina: '5903',
                valor: 1000,
                nombre: 'Volumen',
                url_icono: 'cube.gif',
                unidad: 'Volumen',
                prefijo: '',
                sufijo: 'm3',
                carga: 0,
                nombreOriginal: 'Volumen',
            },
            Palets: {
                id_maquina: '5903',
                valor: 1000,
                nombre: 'Palets',
                url_icono: 'palett.png',
                unidad: 'Palets',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Palets',
            },
            Bultos: {
                id_maquina: '5903',
                valor: 1000,
                nombre: 'Bultos',
                url_icono: 'cajon_bulto_icon.png',
                unidad: 'Bultos',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Bultos',
            },
            Dinero: {
                id_maquina: '5903',
                valor: 1000,
                nombre: 'Dinero',
                url_icono: 'Dollar-Sign.png',
                unidad: 'Dinero',
                prefijo: '$',
                sufijo: '$',
                carga: 0,
                nombreOriginal: 'Dinero',
            },
            Visitas: {
                id_maquina: '5903',
                valor: 1000,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        startTime: 533,
        minTime: 461,
        vueltaDeposito: 0,
        fixedCost: '0',
        kmCost: '0',
        hourCost: '0',
        fixedCostIncludedStops: '0',
        stopCost: '0',
        color: '#70E000',
        descarga: 11342,
        token_expirado: true,
        estado: 'missingPhone',
        parametros: [
            {
                codigo_parametro: 'COLOR_MAQUINA_CHAMELEON',
                valor: '#70E000',
            },
            {
                codigo_parametro: 'DESCARGA',
                valor: '11342',
            },
            {
                codigo_parametro: 'ROUTE_COST_DEFAULT_RATE',
                valor: '66c8c81e87d2d8ffb3cbfa2f',
            },
            {
                codigo_parametro: 'ROUTE_COST_TRIP_TYPE',
                valor: 'Seleccionar Tipo de Viaje...',
            },
        ],
        optimized: false,
        enabled: true,
        maxTime: 500,
        maxDistance: 2000,
    },
    '5904': {
        nombre: 'ABCD008 - costo km - sin regreso',
        patente: 'ABCD008',
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=camion3.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=camion3.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: '11079',
        codigo_erp: 'V1',
        agrupacion: 'TIPO PRODUCTO A',
        id_dispositivo: '5904',
        telefono: '',
        chofer: '10700',
        expiracion_token: null,
        utilizacion_token: null,
        nombre_chofer: 'Raúl Finol',
        rateId: null,
        zonas: [
            '260748',
            '608465',
            '608467',
            '608515',
            '609179',
            '766561',
            '768769',
            '857185',
            '857186',
            '857189',
            '915849',
            '566401977',
            '566401981',
            '566401983',
            '566401987',
        ],
        cortes: {
            Peso: {
                id_maquina: '5904',
                valor: 4500,
                nombre: 'Peso',
                url_icono: 'balanza2.png',
                unidad: 'Kilogramos',
                prefijo: '',
                sufijo: 'kg',
                carga: 0,
                nombreOriginal: 'Peso',
            },
            Volumen: {
                id_maquina: '5904',
                valor: 14,
                nombre: 'Volumen',
                url_icono: 'cube.gif',
                unidad: 'Volumen',
                prefijo: '',
                sufijo: 'm3',
                carga: 0,
                nombreOriginal: 'Volumen',
            },
            Palets: {
                id_maquina: '5904',
                valor: 1500000,
                nombre: 'Palets',
                url_icono: 'palett.png',
                unidad: 'Palets',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Palets',
            },
            Bultos: {
                id_maquina: '5904',
                valor: 1500000,
                nombre: 'Bultos',
                url_icono: 'cajon_bulto_icon.png',
                unidad: 'Bultos',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Bultos',
            },
            Dinero: {
                id_maquina: '5904',
                valor: 1500000,
                nombre: 'Dinero',
                url_icono: 'Dollar-Sign.png',
                unidad: 'Dinero',
                prefijo: '$',
                sufijo: '$',
                carga: 0,
                nombreOriginal: 'Dinero',
            },
            Visitas: {
                id_maquina: '5904',
                valor: 1000,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        startTime: 420,
        minTime: 120,
        vueltaDeposito: 0,
        fixedCost: '0',
        kmCost: '0',
        hourCost: '0',
        fixedCostIncludedStops: '0',
        stopCost: '0',
        color: '#480CA8',
        descarga: 11342,
        token_expirado: true,
        estado: 'missingPhone',
        parametros: [
            {
                codigo_parametro: 'COLOR_MAQUINA_CHAMELEON',
                valor: '#480CA8',
            },
            {
                codigo_parametro: 'DESCARGA',
                valor: '11342',
            },
            {
                codigo_parametro: 'ROUTE_COST_TRIP_TYPE',
                valor: '66e2e9a411f2fd169908bd7f',
            },
        ],
        optimized: false,
        enabled: true,
        maxTime: 500,
        maxDistance: 2000,
    },
    '5908': {
        nombre: 'ABCD005-costo km-sin regreso',
        patente: '',
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=camion3.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=camion3.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: '11079',
        codigo_erp: '6',
        agrupacion: '170',
        id_dispositivo: '5908',
        telefono: '',
        chofer: '19230',
        expiracion_token: null,
        utilizacion_token: null,
        nombre_chofer: 'José Pacheco',
        rateId: null,
        zonas: [
            '0',
            '280939',
            '312957',
            '320581',
            '857185',
            '857187',
            '915185',
            '566401977',
            '566401981',
            '566401983',
            '566401987',
        ],
        cortes: {
            Peso: {
                id_maquina: '5908',
                valor: 4500,
                nombre: 'Peso',
                url_icono: 'balanza2.png',
                unidad: 'Kilogramos',
                prefijo: '',
                sufijo: 'kg',
                carga: 0,
                nombreOriginal: 'Peso',
            },
            Volumen: {
                id_maquina: '5908',
                valor: 14,
                nombre: 'Volumen',
                url_icono: 'cube.gif',
                unidad: 'Volumen',
                prefijo: '',
                sufijo: 'm3',
                carga: 0,
                nombreOriginal: 'Volumen',
            },
            Palets: {
                id_maquina: '5908',
                valor: 1500000,
                nombre: 'Palets',
                url_icono: 'palett.png',
                unidad: 'Palets',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Palets',
            },
            Bultos: {
                id_maquina: '5908',
                valor: 1500000,
                nombre: 'Bultos',
                url_icono: 'cajon_bulto_icon.png',
                unidad: 'Bultos',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Bultos',
            },
            Dinero: {
                id_maquina: '5908',
                valor: 1500000,
                nombre: 'Dinero',
                url_icono: 'Dollar-Sign.png',
                unidad: 'Dinero',
                prefijo: '$',
                sufijo: '$',
                carga: 0,
                nombreOriginal: 'Dinero',
            },
            Visitas: {
                id_maquina: '5908',
                valor: 35,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        startTime: 420,
        minTime: 120,
        vueltaDeposito: 0,
        fixedCost: '0',
        kmCost: '0',
        hourCost: '0',
        fixedCostIncludedStops: '0',
        stopCost: '0',
        color: '#FF0084',
        descarga: 11342,
        token_expirado: true,
        estado: 'missingPhone',
        parametros: [
            {
                codigo_parametro: 'COLOR_MAQUINA_CHAMELEON',
                valor: '#FF0084',
            },
            {
                codigo_parametro: 'DESCARGA',
                valor: '11342',
            },
        ],
        optimized: false,
        enabled: true,
        maxTime: 500,
        maxDistance: 2000,
    },
    '15777': {
        nombre: 'ABCD015',
        patente: 'ABCD015',
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=camion1.png&color=FFFFFF&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=camion1.png&color=FFFFFF&negative=0',
        id_deposito: '11260',
        id_deposito_fin: '24141',
        codigo_erp: '',
        agrupacion: '810',
        id_dispositivo: '15777',
        telefono: '',
        chofer: '19232',
        expiracion_token: null,
        utilizacion_token: null,
        nombre_chofer: 'Gonzalo Arriagada',
        rateId: null,
        zonas: ['609181', '566401977', '566401981', '566401983', '566401987'],
        cortes: {
            Peso: {
                id_maquina: '15777',
                valor: 4500,
                nombre: 'Peso',
                url_icono: 'balanza2.png',
                unidad: 'Kilogramos',
                prefijo: '',
                sufijo: 'kg',
                carga: 0,
                nombreOriginal: 'Peso',
            },
            Volumen: {
                id_maquina: '15777',
                valor: 14,
                nombre: 'Volumen',
                url_icono: 'cube.gif',
                unidad: 'Volumen',
                prefijo: '',
                sufijo: 'm3',
                carga: 0,
                nombreOriginal: 'Volumen',
            },
            Palets: {
                id_maquina: '15777',
                valor: 1500000,
                nombre: 'Palets',
                url_icono: 'palett.png',
                unidad: 'Palets',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Palets',
            },
            Bultos: {
                id_maquina: '15777',
                valor: 1500000,
                nombre: 'Bultos',
                url_icono: 'cajon_bulto_icon.png',
                unidad: 'Bultos',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Bultos',
            },
            Dinero: {
                id_maquina: '15777',
                valor: 1500000,
                nombre: 'Dinero',
                url_icono: 'Dollar-Sign.png',
                unidad: 'Dinero',
                prefijo: '$',
                sufijo: '$',
                carga: 0,
                nombreOriginal: 'Dinero',
            },
            Visitas: {
                id_maquina: '15777',
                valor: 35,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        startTime: 420,
        vueltaDeposito: 1,
        fixedCost: '0',
        kmCost: '1750',
        hourCost: '0',
        fixedCostIncludedStops: '0',
        stopCost: '0',
        color: '#03A9F4',
        descarga: 11342,
        token_expirado: true,
        estado: 'missingPhone',
        parametros: [
            {
                codigo_parametro: 'COLOR_MAQUINA_CHAMELEON',
                valor: '#03A9F4',
            },
            {
                codigo_parametro: 'DESCARGA',
                valor: '11342',
            },
        ],
        optimized: false,
        enabled: true,
        maxTime: 500,
        minTime: 0,
        maxDistance: 2000,
    },
    '15805': {
        nombre: 'ABCD003-costo hora',
        patente: '',
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=CamionCisterna.png&color=FFFFFF&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=CamionCisterna.png&color=FFFFFF&negative=0',
        id_deposito: '11260',
        id_deposito_fin: '11079',
        codigo_erp: '5',
        agrupacion: '810',
        id_dispositivo: '15805',
        telefono: '',
        chofer: '20003',
        expiracion_token: null,
        utilizacion_token: null,
        nombre_chofer: 'Gregorio Gonzalez',
        rateId: null,
        zonas: ['915185', '566401977', '566401981', '566401983', '566401987'],
        cortes: {
            Peso: {
                id_maquina: '15805',
                valor: 45000,
                nombre: 'Peso',
                url_icono: 'balanza2.png',
                unidad: 'Kilogramos',
                prefijo: '',
                sufijo: 'kg',
                carga: 0,
                nombreOriginal: 'Peso',
            },
            Volumen: {
                id_maquina: '15805',
                valor: 14,
                nombre: 'Volumen',
                url_icono: 'cube.gif',
                unidad: 'Volumen',
                prefijo: '',
                sufijo: 'm3',
                carga: 0,
                nombreOriginal: 'Volumen',
            },
            Palets: {
                id_maquina: '15805',
                valor: 1500000,
                nombre: 'Palets',
                url_icono: 'palett.png',
                unidad: 'Palets',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Palets',
            },
            Bultos: {
                id_maquina: '15805',
                valor: 1500000,
                nombre: 'Bultos',
                url_icono: 'cajon_bulto_icon.png',
                unidad: 'Bultos',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Bultos',
            },
            Dinero: {
                id_maquina: '15805',
                valor: 1500000,
                nombre: 'Dinero',
                url_icono: 'Dollar-Sign.png',
                unidad: 'Dinero',
                prefijo: '$',
                sufijo: '$',
                carga: 0,
                nombreOriginal: 'Dinero',
            },
            Visitas: {
                id_maquina: '15805',
                valor: 35,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        startTime: 420,
        minTime: 120,
        vueltaDeposito: 1,
        fixedCost: '0',
        kmCost: '0',
        fixedCostIncludedStops: '0',
        stopCost: '0',
        color: '#6BBA70',
        descarga: 11342,
        token_expirado: true,
        estado: 'missingPhone',
        parametros: [
            {
                codigo_parametro: 'COLOR_MAQUINA_CHAMELEON',
                valor: '#6BBA70',
            },
            {
                codigo_parametro: 'DESCARGA',
                valor: '11342',
            },
        ],
        optimized: false,
        enabled: true,
        maxTime: 500,
        maxDistance: 2000,
    },
    '116064': {
        nombre: 'ABCD004-cantidad paradas',
        patente: '',
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=camion4.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=camion4.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: '11079',
        codigo_erp: '',
        agrupacion: null,
        id_dispositivo: '116064',
        telefono: '',
        chofer: '25114',
        expiracion_token: null,
        utilizacion_token: null,
        nombre_chofer: 'Domingo Ramones',
        rateId: null,
        zonas: ['0', '915185'],
        cortes: {
            Peso: {
                id_maquina: '116064',
                valor: 4500,
                nombre: 'Peso',
                url_icono: 'balanza2.png',
                unidad: 'Kilogramos',
                prefijo: '',
                sufijo: 'kg',
                carga: 0,
                nombreOriginal: 'Peso',
            },
            Volumen: {
                id_maquina: '116064',
                valor: 14,
                nombre: 'Volumen',
                url_icono: 'cube.gif',
                unidad: 'Volumen',
                prefijo: '',
                sufijo: 'm3',
                carga: 0,
                nombreOriginal: 'Volumen',
            },
            Palets: {
                id_maquina: '116064',
                valor: 1500000,
                nombre: 'Palets',
                url_icono: 'palett.png',
                unidad: 'Palets',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Palets',
            },
            Bultos: {
                id_maquina: '116064',
                valor: 1500000,
                nombre: 'Bultos',
                url_icono: 'cajon_bulto_icon.png',
                unidad: 'Bultos',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Bultos',
            },
            Dinero: {
                id_maquina: '116064',
                valor: 1500000,
                nombre: 'Dinero',
                url_icono: 'Dollar-Sign.png',
                unidad: 'Dinero',
                prefijo: '$',
                sufijo: '$',
                carga: 0,
                nombreOriginal: 'Dinero',
            },
            Visitas: {
                id_maquina: '116064',
                valor: 35,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        startTime: 420,
        minTime: 120,
        vueltaDeposito: 1,
        fixedCost: '0',
        kmCost: '0',
        hourCost: '0',
        fixedCostIncludedStops: '0',
        stopCost: '0',
        color: '#480CA8',
        descarga: 11342,
        token_expirado: true,
        estado: 'missingPhone',
        parametros: [
            {
                codigo_parametro: 'COLOR_MAQUINA_CHAMELEON',
                valor: '#480CA8',
            },
            {
                codigo_parametro: 'DESCARGA',
                valor: '11342',
            },
        ],
        optimized: false,
        enabled: true,
        maxTime: 500,
        maxDistance: 2000,
    },
    '116065': {
        nombre: 'ABCD002-costo km',
        patente: '',
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=camion4.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=camion4.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: null,
        codigo_erp: '',
        agrupacion: null,
        id_dispositivo: '116065',
        telefono: '',
        chofer: '25616',
        expiracion_token: null,
        utilizacion_token: null,
        nombre_chofer: 'Gabriel Zamudio',
        rateId: null,
        zonas: ['915185'],
        cortes: {
            Peso: {
                id_maquina: '116065',
                valor: 4500,
                nombre: 'Peso',
                url_icono: 'balanza2.png',
                unidad: 'Kilogramos',
                prefijo: '',
                sufijo: 'kg',
                carga: 0,
                nombreOriginal: 'Peso',
            },
            Volumen: {
                id_maquina: '116065',
                valor: 14,
                nombre: 'Volumen',
                url_icono: 'cube.gif',
                unidad: 'Volumen',
                prefijo: '',
                sufijo: 'm3',
                carga: 0,
                nombreOriginal: 'Volumen',
            },
            Palets: {
                id_maquina: '116065',
                valor: 1500000,
                nombre: 'Palets',
                url_icono: 'palett.png',
                unidad: 'Palets',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Palets',
            },
            Bultos: {
                id_maquina: '116065',
                valor: 1500000,
                nombre: 'Bultos',
                url_icono: 'cajon_bulto_icon.png',
                unidad: 'Bultos',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Bultos',
            },
            Dinero: {
                id_maquina: '116065',
                valor: 1500000,
                nombre: 'Dinero',
                url_icono: 'Dollar-Sign.png',
                unidad: 'Dinero',
                prefijo: '$',
                sufijo: '$',
                carga: 0,
                nombreOriginal: 'Dinero',
            },
            Visitas: {
                id_maquina: '116065',
                valor: 35,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        startTime: 420,
        minTime: 120,
        vueltaDeposito: 1,
        fixedCost: '0',
        kmCost: '1500',
        hourCost: '0',
        fixedCostIncludedStops: '0',
        stopCost: '0',
        color: '#EF233C',
        descarga: 28495,
        token_expirado: true,
        estado: 'missingPhone',
        parametros: [
            {
                codigo_parametro: 'COLOR_MAQUINA_CHAMELEON',
                valor: '#EF233C',
            },
            {
                codigo_parametro: 'DESCARGA',
                valor: '28495',
            },
        ],
        optimized: false,
        enabled: true,
        maxTime: 500,
        maxDistance: 2000,
    },
    '116066': {
        nombre: 'ABCD006-costo hora-sin regreso',
        patente: '',
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=camion4.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=camion4.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: '11079',
        codigo_erp: '',
        agrupacion: null,
        id_dispositivo: '116066',
        telefono: '',
        chofer: '26800',
        expiracion_token: null,
        utilizacion_token: null,
        nombre_chofer: 'Nerio Webber',
        rateId: null,
        zonas: [],
        cortes: {
            Peso: {
                id_maquina: '116066',
                valor: 4500,
                nombre: 'Peso',
                url_icono: 'balanza2.png',
                unidad: 'Kilogramos',
                prefijo: '',
                sufijo: 'kg',
                carga: 0,
                nombreOriginal: 'Peso',
            },
            Volumen: {
                id_maquina: '116066',
                valor: 14,
                nombre: 'Volumen',
                url_icono: 'cube.gif',
                unidad: 'Volumen',
                prefijo: '',
                sufijo: 'm3',
                carga: 0,
                nombreOriginal: 'Volumen',
            },
            Palets: {
                id_maquina: '116066',
                valor: 1500000,
                nombre: 'Palets',
                url_icono: 'palett.png',
                unidad: 'Palets',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Palets',
            },
            Bultos: {
                id_maquina: '116066',
                valor: 1500000,
                nombre: 'Bultos',
                url_icono: 'cajon_bulto_icon.png',
                unidad: 'Bultos',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Bultos',
            },
            Dinero: {
                id_maquina: '116066',
                valor: 1500000,
                nombre: 'Dinero',
                url_icono: 'Dollar-Sign.png',
                unidad: 'Dinero',
                prefijo: '$',
                sufijo: '$',
                carga: 0,
                nombreOriginal: 'Dinero',
            },
            Visitas: {
                id_maquina: '116066',
                valor: 35,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        startTime: 420,
        minTime: 120,
        vueltaDeposito: 0,
        fixedCost: '0',
        kmCost: '0',
        hourCost: '2300',
        fixedCostIncludedStops: '0',
        stopCost: '0',
        color: '#F9844A',
        descarga: 11342,
        token_expirado: true,
        estado: 'missingPhone',
        parametros: [
            {
                codigo_parametro: 'COLOR_MAQUINA_CHAMELEON',
                valor: '#F9844A',
            },
            {
                codigo_parametro: 'DESCARGA',
                valor: '11342',
            },
        ],
        optimized: false,
        enabled: true,
        maxTime: 500,
        maxDistance: 2000,
    },
    '116067': {
        nombre: 'ABCD007 - costo fijo',
        patente: 'ABCD007',
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=camion4.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=camion4.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: '24792',
        codigo_erp: '',
        agrupacion: null,
        id_dispositivo: '116067',
        telefono: '',
        chofer: '30118',
        expiracion_token: null,
        utilizacion_token: null,
        nombre_chofer: 'Aristóbulo Negrete',
        rateId: null,
        zonas: [],
        cortes: {
            Peso: {
                id_maquina: '116067',
                valor: 10000,
                nombre: 'Peso',
                url_icono: 'balanza2.png',
                unidad: 'Kilogramos',
                prefijo: '',
                sufijo: 'kg',
                carga: 0,
                nombreOriginal: 'Peso',
            },
            Volumen: {
                id_maquina: '116067',
                valor: 14,
                nombre: 'Volumen',
                url_icono: 'cube.gif',
                unidad: 'Volumen',
                prefijo: '',
                sufijo: 'm3',
                carga: 0,
                nombreOriginal: 'Volumen',
            },
            Palets: {
                id_maquina: '116067',
                valor: 1500000,
                nombre: 'Palets',
                url_icono: 'palett.png',
                unidad: 'Palets',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Palets',
            },
            Bultos: {
                id_maquina: '116067',
                valor: 1500000,
                nombre: 'Bultos',
                url_icono: 'cajon_bulto_icon.png',
                unidad: 'Bultos',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Bultos',
            },
            Dinero: {
                id_maquina: '116067',
                valor: 1500000,
                nombre: 'Dinero',
                url_icono: 'Dollar-Sign.png',
                unidad: 'Dinero',
                prefijo: '$',
                sufijo: '$',
                carga: 0,
                nombreOriginal: 'Dinero',
            },
            Visitas: {
                id_maquina: '116067',
                valor: 35,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        startTime: 420,
        minTime: 120,
        vueltaDeposito: 1,
        fixedCost: '60000',
        kmCost: '0',
        hourCost: '0',
        fixedCostIncludedStops: '0',
        stopCost: '0',
        color: '#FFD500',
        descarga: 28495,
        token_expirado: true,
        estado: 'missingPhone',
        parametros: [
            {
                codigo_parametro: 'COLOR_MAQUINA_CHAMELEON',
                valor: '#FFD500',
            },
            {
                codigo_parametro: 'DESCARGA',
                valor: '28495',
            },
        ],
        optimized: false,
        enabled: true,
        maxTime: 500,
        maxDistance: 2000,
    },
    '117096': {
        nombre: 'ABCD014',
        patente: 'ABCD014',
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=CamionCisterna.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=CamionCisterna.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: '11079',
        codigo_erp: '',
        agrupacion: null,
        id_dispositivo: '117096',
        telefono: '',
        chofer: '30368',
        expiracion_token: null,
        utilizacion_token: null,
        nombre_chofer: 'Sergio Morales',
        rateId: null,
        zonas: [],
        cortes: {
            Peso: {
                id_maquina: '117096',
                valor: 10000,
                nombre: 'Peso',
                url_icono: 'balanza2.png',
                unidad: 'Kilogramos',
                prefijo: '',
                sufijo: 'kg',
                carga: 0,
                nombreOriginal: 'Peso',
            },
            Volumen: {
                id_maquina: '117096',
                valor: 14,
                nombre: 'Volumen',
                url_icono: 'cube.gif',
                unidad: 'Volumen',
                prefijo: '',
                sufijo: 'm3',
                carga: 0,
                nombreOriginal: 'Volumen',
            },
            Palets: {
                id_maquina: '117096',
                valor: 1500000,
                nombre: 'Palets',
                url_icono: 'palett.png',
                unidad: 'Palets',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Palets',
            },
            Bultos: {
                id_maquina: '117096',
                valor: 1500000,
                nombre: 'Bultos',
                url_icono: 'cajon_bulto_icon.png',
                unidad: 'Bultos',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Bultos',
            },
            Dinero: {
                id_maquina: '117096',
                valor: 1500000,
                nombre: 'Dinero',
                url_icono: 'Dollar-Sign.png',
                unidad: 'Dinero',
                prefijo: '$',
                sufijo: '$',
                carga: 0,
                nombreOriginal: 'Dinero',
            },
            Visitas: {
                id_maquina: '117096',
                valor: 35,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        startTime: 420,
        vueltaDeposito: 1,
        fixedCost: '0',
        kmCost: '0',
        hourCost: '0',
        fixedCostIncludedStops: '0',
        stopCost: '0',
        color: '#FF603B',
        descarga: 11260,
        token_expirado: true,
        estado: 'missingPhone',
        parametros: [
            {
                codigo_parametro: 'COLOR_MAQUINA_CHAMELEON',
                valor: '#FF603B',
            },
            {
                codigo_parametro: 'DESCARGA',
                valor: '11260',
            },
        ],
        optimized: false,
        enabled: true,
        maxTime: 500,
        minTime: 0,
        maxDistance: 2000,
    },
    '117106': {
        nombre: 'ABCD013',
        patente: 'ABCD013',
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=CamionCisterna.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=CamionCisterna.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: '11079',
        codigo_erp: '',
        agrupacion: null,
        id_dispositivo: '117106',
        telefono: '',
        chofer: '30600',
        expiracion_token: null,
        utilizacion_token: null,
        nombre_chofer: 'Alberto Correa',
        rateId: null,
        zonas: [],
        cortes: {
            Peso: {
                id_maquina: '117106',
                valor: 15000,
                nombre: 'Peso',
                url_icono: 'balanza2.png',
                unidad: 'Kilogramos',
                prefijo: '',
                sufijo: 'kg',
                carga: 0,
                nombreOriginal: 'Peso',
            },
            Volumen: {
                id_maquina: '117106',
                valor: 14,
                nombre: 'Volumen',
                url_icono: 'cube.gif',
                unidad: 'Volumen',
                prefijo: '',
                sufijo: 'm3',
                carga: 0,
                nombreOriginal: 'Volumen',
            },
            Palets: {
                id_maquina: '117106',
                valor: 1500000,
                nombre: 'Palets',
                url_icono: 'palett.png',
                unidad: 'Palets',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Palets',
            },
            Bultos: {
                id_maquina: '117106',
                valor: 1500000,
                nombre: 'Bultos',
                url_icono: 'cajon_bulto_icon.png',
                unidad: 'Bultos',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Bultos',
            },
            Dinero: {
                id_maquina: '117106',
                valor: 1500000,
                nombre: 'Dinero',
                url_icono: 'Dollar-Sign.png',
                unidad: 'Dinero',
                prefijo: '$',
                sufijo: '$',
                carga: 0,
                nombreOriginal: 'Dinero',
            },
            Visitas: {
                id_maquina: '117106',
                valor: 35,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        startTime: 420,
        vueltaDeposito: 1,
        fixedCost: '0',
        kmCost: '0',
        hourCost: '0',
        fixedCostIncludedStops: '0',
        stopCost: '0',
        color: '#3F4C6B',
        descarga: 11260,
        token_expirado: true,
        estado: 'missingPhone',
        parametros: [
            {
                codigo_parametro: 'COLOR_MAQUINA_CHAMELEON',
                valor: '#3F4C6B',
            },
            {
                codigo_parametro: 'DESCARGA',
                valor: '11260',
            },
        ],
        optimized: false,
        enabled: true,
        maxTime: 500,
        minTime: 0,
        maxDistance: 2000,
    },
    '117112': {
        nombre: 'ABCD012',
        patente: 'ABCD012',
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=CamionCisterna.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=CamionCisterna.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: '24772',
        codigo_erp: '',
        agrupacion: null,
        id_dispositivo: '117112',
        telefono: '',
        chofer: '30606',
        expiracion_token: null,
        utilizacion_token: null,
        nombre_chofer: 'Sandra Klein',
        rateId: null,
        zonas: [],
        cortes: {
            Peso: {
                id_maquina: '117112',
                valor: 4500,
                nombre: 'Peso',
                url_icono: 'balanza2.png',
                unidad: 'Kilogramos',
                prefijo: '',
                sufijo: 'kg',
                carga: 0,
                nombreOriginal: 'Peso',
            },
            Volumen: {
                id_maquina: '117112',
                valor: 14,
                nombre: 'Volumen',
                url_icono: 'cube.gif',
                unidad: 'Volumen',
                prefijo: '',
                sufijo: 'm3',
                carga: 0,
                nombreOriginal: 'Volumen',
            },
            Palets: {
                id_maquina: '117112',
                valor: 1500000,
                nombre: 'Palets',
                url_icono: 'palett.png',
                unidad: 'Palets',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Palets',
            },
            Bultos: {
                id_maquina: '117112',
                valor: 1500000,
                nombre: 'Bultos',
                url_icono: 'cajon_bulto_icon.png',
                unidad: 'Bultos',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Bultos',
            },
            Dinero: {
                id_maquina: '117112',
                valor: 1500000,
                nombre: 'Dinero',
                url_icono: 'Dollar-Sign.png',
                unidad: 'Dinero',
                prefijo: '$',
                sufijo: '$',
                carga: 0,
                nombreOriginal: 'Dinero',
            },
            Visitas: {
                id_maquina: '117112',
                valor: 35,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        startTime: 420,
        vueltaDeposito: 1,
        fixedCost: '0',
        kmCost: '0',
        hourCost: '0',
        fixedCostIncludedStops: '0',
        stopCost: '0',
        color: '#A609CC',
        descarga: 11342,
        token_expirado: true,
        estado: 'missingPhone',
        parametros: [
            {
                codigo_parametro: 'COLOR_MAQUINA_CHAMELEON',
                valor: '#A609CC',
            },
            {
                codigo_parametro: 'DESCARGA',
                valor: '11342',
            },
        ],
        optimized: false,
        enabled: true,
        maxTime: 500,
        minTime: 0,
        maxDistance: 2000,
    },
    '117113': {
        nombre: 'ABCD009 - cantidad paradas',
        patente: 'ABCD009',
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=CamionCisterna.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=CamionCisterna.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: '24800',
        codigo_erp: '',
        agrupacion: null,
        id_dispositivo: '117113',
        telefono: '',
        chofer: '30684',
        expiracion_token: null,
        utilizacion_token: null,
        nombre_chofer: 'Horacio Aravena',
        rateId: null,
        zonas: [],
        cortes: {
            Peso: {
                id_maquina: '117113',
                valor: 15000,
                nombre: 'Peso',
                url_icono: 'balanza2.png',
                unidad: 'Kilogramos',
                prefijo: '',
                sufijo: 'kg',
                carga: 0,
                nombreOriginal: 'Peso',
            },
            Volumen: {
                id_maquina: '117113',
                valor: 14,
                nombre: 'Volumen',
                url_icono: 'cube.gif',
                unidad: 'Volumen',
                prefijo: '',
                sufijo: 'm3',
                carga: 0,
                nombreOriginal: 'Volumen',
            },
            Palets: {
                id_maquina: '117113',
                valor: 1500000,
                nombre: 'Palets',
                url_icono: 'palett.png',
                unidad: 'Palets',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Palets',
            },
            Bultos: {
                id_maquina: '117113',
                valor: 1500000,
                nombre: 'Bultos',
                url_icono: 'cajon_bulto_icon.png',
                unidad: 'Bultos',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Bultos',
            },
            Dinero: {
                id_maquina: '117113',
                valor: 1500000,
                nombre: 'Dinero',
                url_icono: 'Dollar-Sign.png',
                unidad: 'Dinero',
                prefijo: '$',
                sufijo: '$',
                carga: 0,
                nombreOriginal: 'Dinero',
            },
            Visitas: {
                id_maquina: '117113',
                valor: 35,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        startTime: 420,
        minTime: 120,
        vueltaDeposito: 1,
        fixedCost: '0',
        kmCost: '0',
        hourCost: '0',
        fixedCostIncludedStops: '0',
        stopCost: '0',
        color: '#06CEBB',
        descarga: 11260,
        token_expirado: true,
        estado: 'missingPhone',
        parametros: [
            {
                codigo_parametro: 'COLOR_MAQUINA_CHAMELEON',
                valor: '#06CEBB',
            },
            {
                codigo_parametro: 'DESCARGA',
                valor: '11260',
            },
            {
                codigo_parametro: 'ROUTE_COST_DEFAULT_RATE',
                valor: '66c8c81e87d2d8ffb3cbfa2f',
            },
        ],
        optimized: false,
        enabled: true,
        maxTime: 500,
        maxDistance: 2000,
    },
    '117114': {
        nombre: 'ABCD011 - cantidad de paradas',
        patente: 'ABCD011',
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=CamionCisterna.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=CamionCisterna.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: '24800',
        codigo_erp: '',
        agrupacion: null,
        id_dispositivo: '117114',
        telefono: '',
        chofer: '30734',
        expiracion_token: null,
        utilizacion_token: null,
        nombre_chofer: 'Fabrizio Larena',
        rateId: null,
        zonas: [],
        cortes: {
            Peso: {
                id_maquina: '117114',
                valor: 4500,
                nombre: 'Peso',
                url_icono: 'balanza2.png',
                unidad: 'Kilogramos',
                prefijo: '',
                sufijo: 'kg',
                carga: 0,
                nombreOriginal: 'Peso',
            },
            Volumen: {
                id_maquina: '117114',
                valor: 14,
                nombre: 'Volumen',
                url_icono: 'cube.gif',
                unidad: 'Volumen',
                prefijo: '',
                sufijo: 'm3',
                carga: 0,
                nombreOriginal: 'Volumen',
            },
            Palets: {
                id_maquina: '117114',
                valor: 1500000,
                nombre: 'Palets',
                url_icono: 'palett.png',
                unidad: 'Palets',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Palets',
            },
            Bultos: {
                id_maquina: '117114',
                valor: 1500000,
                nombre: 'Bultos',
                url_icono: 'cajon_bulto_icon.png',
                unidad: 'Bultos',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Bultos',
            },
            Dinero: {
                id_maquina: '117114',
                valor: 1500000,
                nombre: 'Dinero',
                url_icono: 'Dollar-Sign.png',
                unidad: 'Dinero',
                prefijo: '$',
                sufijo: '$',
                carga: 0,
                nombreOriginal: 'Dinero',
            },
            Visitas: {
                id_maquina: '117114',
                valor: 35,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        startTime: 420,
        minTime: 120,
        vueltaDeposito: 1,
        fixedCost: '1500',
        kmCost: '0',
        hourCost: '0',
        fixedCostIncludedStops: '20',
        stopCost: '1000',
        color: '#356AA0',
        descarga: 28495,
        token_expirado: true,
        estado: 'missingPhone',
        parametros: [
            {
                codigo_parametro: 'COLOR_MAQUINA_CHAMELEON',
                valor: '#356AA0',
            },
            {
                codigo_parametro: 'DESCARGA',
                valor: '28495',
            },
        ],
        optimized: false,
        enabled: true,
        maxTime: 500,
        maxDistance: 2000,
    },
    '117115': {
        nombre: 'ABCD001-costo fijo',
        patente: '',
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=CamionCisterna.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=CamionCisterna.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: '24800',
        codigo_erp: 'Usieto 1',
        agrupacion: null,
        id_dispositivo: '117115',
        telefono: '',
        chofer: '30740',
        expiracion_token: null,
        utilizacion_token: null,
        nombre_chofer: 'Tomas Campos',
        rateId: null,
        zonas: ['915185'],
        cortes: {
            Peso: {
                id_maquina: '117115',
                valor: 4500,
                nombre: 'Peso',
                url_icono: 'balanza2.png',
                unidad: 'Kilogramos',
                prefijo: '',
                sufijo: 'kg',
                carga: 0,
                nombreOriginal: 'Peso',
            },
            Volumen: {
                id_maquina: '117115',
                valor: 14,
                nombre: 'Volumen',
                url_icono: 'cube.gif',
                unidad: 'Volumen',
                prefijo: '',
                sufijo: 'm3',
                carga: 0,
                nombreOriginal: 'Volumen',
            },
            Palets: {
                id_maquina: '117115',
                valor: 1500000,
                nombre: 'Palets',
                url_icono: 'palett.png',
                unidad: 'Palets',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Palets',
            },
            Bultos: {
                id_maquina: '117115',
                valor: 1500000,
                nombre: 'Bultos',
                url_icono: 'cajon_bulto_icon.png',
                unidad: 'Bultos',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Bultos',
            },
            Dinero: {
                id_maquina: '117115',
                valor: 1500000,
                nombre: 'Dinero',
                url_icono: 'Dollar-Sign.png',
                unidad: 'Dinero',
                prefijo: '$',
                sufijo: '$',
                carga: 0,
                nombreOriginal: 'Dinero',
            },
            Visitas: {
                id_maquina: '117115',
                valor: 35,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        maxTime: 480,
        maxDistance: 100,
        startTime: 1380,
        minTime: 120,
        vueltaDeposito: 1,
        fixedCost: '55000',
        kmCost: '0',
        hourCost: '0',
        fixedCostIncludedStops: '0',
        stopCost: '0',
        color: '#4873FE',
        descarga: 28495,
        token_expirado: true,
        estado: 'missingPhone',
        parametros: [
            {
                codigo_parametro: 'COLOR_MAQUINA_CHAMELEON',
                valor: '#4873FE',
            },
            {
                codigo_parametro: 'DESCARGA',
                valor: '28495',
            },
        ],
        optimized: false,
        enabled: true,
    },
    '117116': {
        nombre: 'ABCD010 - costo km',
        patente: 'ABCD010',
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=CamionCisterna.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=CamionCisterna.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: '24800',
        codigo_erp: '',
        agrupacion: null,
        id_dispositivo: '117116',
        telefono: '',
        chofer: '32829',
        expiracion_token: null,
        utilizacion_token: null,
        nombre_chofer: 'Camilo Flores',
        rateId: null,
        zonas: [],
        cortes: {
            Peso: {
                id_maquina: '117116',
                valor: 4500,
                nombre: 'Peso',
                url_icono: 'balanza2.png',
                unidad: 'Kilogramos',
                prefijo: '',
                sufijo: 'kg',
                carga: 0,
                nombreOriginal: 'Peso',
            },
            Volumen: {
                id_maquina: '117116',
                valor: 14,
                nombre: 'Volumen',
                url_icono: 'cube.gif',
                unidad: 'Volumen',
                prefijo: '',
                sufijo: 'm3',
                carga: 0,
                nombreOriginal: 'Volumen',
            },
            Palets: {
                id_maquina: '117116',
                valor: 1500000,
                nombre: 'Palets',
                url_icono: 'palett.png',
                unidad: 'Palets',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Palets',
            },
            Bultos: {
                id_maquina: '117116',
                valor: 1500000,
                nombre: 'Bultos',
                url_icono: 'cajon_bulto_icon.png',
                unidad: 'Bultos',
                prefijo: '',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Bultos',
            },
            Dinero: {
                id_maquina: '117116',
                valor: 1500000,
                nombre: 'Dinero',
                url_icono: 'Dollar-Sign.png',
                unidad: 'Dinero',
                prefijo: '$',
                sufijo: '$',
                carga: 0,
                nombreOriginal: 'Dinero',
            },
            Visitas: {
                id_maquina: '117116',
                valor: 35,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        startTime: 420,
        minTime: 120,
        vueltaDeposito: 1,
        fixedCost: '0',
        kmCost: '1700',
        hourCost: '0',
        fixedCostIncludedStops: '0',
        stopCost: '0',
        color: '#9900FF',
        descarga: 28495,
        token_expirado: true,
        estado: 'missingPhone',
        parametros: [
            {
                codigo_parametro: 'COLOR_MAQUINA_CHAMELEON',
                valor: '#9900FF',
            },
            {
                codigo_parametro: 'DESCARGA',
                valor: '28495',
            },
        ],
        optimized: false,
        enabled: true,
        maxTime: 500,
        maxDistance: 2000,
    },
    '166391156691234': {
        nombre: 'Vendedor 1',
        patente: null,
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=telefono2.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=telefono2.png&color=ffffff&negative=0',
        id_deposito: '28687',
        id_deposito_fin: null,
        codigo_erp: null,
        agrupacion: null,
        id_dispositivo: '166391156691234',
        telefono: '5491156691234',
        chofer: '167337',
        expiracion_token: '2025-01-18 14:15:03',
        utilizacion_token: null,
        nombre_chofer: 'Vendedor 1',
        rateId: null,
        zonas: [],
        cortes: {
            Visitas: {
                id_maquina: '166391156691234',
                valor: 100,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        maxTime: 1380,
        maxDistance: 500,
        startTime: 480,
        minTime: 0,
        vueltaDeposito: 0,
        color: '#A609CC',
        descarga: 0,
        token_expirado: true,
        estado: 'expired',
        parametros: [
            {
                codigo_parametro: 'COLOR_MAQUINA_CHAMELEON',
                valor: '#A609CC',
            },
            {
                codigo_parametro: 'DESCARGA',
                valor: '0',
            },
        ],
        optimized: false,
        enabled: true,
    },
    '166391156701234': {
        nombre: 'Vendedor 2',
        patente: null,
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=telefono2.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=telefono2.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: null,
        codigo_erp: null,
        agrupacion: null,
        id_dispositivo: '166391156701234',
        telefono: '5491156701234',
        chofer: '167338',
        expiracion_token: '2025-01-18 14:15:09',
        utilizacion_token: null,
        nombre_chofer: 'Vendedor 2',
        rateId: null,
        zonas: [],
        cortes: {
            Visitas: {
                id_maquina: '166391156701234',
                valor: 100,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        maxTime: 1440,
        maxDistance: 500,
        startTime: 480,
        minTime: 0,
        vueltaDeposito: 0,
        color: '#FF1A00',
        descarga: 0,
        token_expirado: true,
        estado: 'expired',
        parametros: [],
        optimized: false,
        enabled: true,
    },
    '166391156721234': {
        nombre: 'Vendedor 3',
        patente: null,
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=telefono2.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=telefono2.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: null,
        codigo_erp: null,
        agrupacion: null,
        id_dispositivo: '166391156721234',
        telefono: '5491156721234',
        chofer: '167339',
        expiracion_token: '2025-01-18 14:15:13',
        utilizacion_token: null,
        nombre_chofer: 'Vendedor 3',
        rateId: null,
        zonas: [],
        cortes: {
            Visitas: {
                id_maquina: '166391156721234',
                valor: 100,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        maxTime: 1440,
        maxDistance: 500,
        startTime: 480,
        minTime: 0,
        vueltaDeposito: 0,
        color: '#00AFB9',
        descarga: 0,
        token_expirado: true,
        estado: 'expired',
        parametros: [],
        optimized: false,
        enabled: true,
    },
    '166391155581234': {
        nombre: 'Vendedora 4',
        patente: null,
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=telefono2.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=telefono2.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: null,
        codigo_erp: null,
        agrupacion: null,
        id_dispositivo: '166391155581234',
        telefono: '5491155581234',
        chofer: '167333',
        expiracion_token: '2025-01-18 14:12:31',
        utilizacion_token: null,
        nombre_chofer: 'Vendedora 4',
        rateId: null,
        zonas: [],
        cortes: {
            Visitas: {
                id_maquina: '166391155581234',
                valor: 100,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        maxTime: 1440,
        maxDistance: 500,
        startTime: 480,
        minTime: 0,
        vueltaDeposito: 0,
        color: '#00F5D4',
        descarga: 0,
        token_expirado: true,
        estado: 'expired',
        parametros: [],
        optimized: false,
        enabled: true,
    },
    '166391155591234': {
        nombre: 'Vendedora 5',
        patente: null,
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=telefono2.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=telefono2.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: null,
        codigo_erp: null,
        agrupacion: null,
        id_dispositivo: '166391155591234',
        telefono: '5491155591234',
        chofer: '167334',
        expiracion_token: '2025-01-18 14:11:04',
        utilizacion_token: null,
        nombre_chofer: 'Vendedora 5',
        rateId: null,
        zonas: [],
        cortes: {
            Visitas: {
                id_maquina: '166391155591234',
                valor: 100,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        maxTime: 1440,
        maxDistance: 500,
        startTime: 480,
        minTime: 0,
        vueltaDeposito: 0,
        color: '#1E6091',
        descarga: 0,
        token_expirado: true,
        estado: 'expired',
        parametros: [],
        optimized: false,
        enabled: true,
    },
    '166391155601234': {
        nombre: 'Vendedora 6',
        patente: null,
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=telefono2.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=telefono2.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: null,
        codigo_erp: null,
        agrupacion: null,
        id_dispositivo: '166391155601234',
        telefono: '5491155601234',
        chofer: '167335',
        expiracion_token: '2025-01-18 14:12:37',
        utilizacion_token: null,
        nombre_chofer: 'Vendedora 6',
        rateId: null,
        zonas: [],
        cortes: {
            Visitas: {
                id_maquina: '166391155601234',
                valor: 100,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        maxTime: 1440,
        maxDistance: 500,
        startTime: 480,
        minTime: 0,
        vueltaDeposito: 0,
        color: '#06AED5',
        descarga: 0,
        token_expirado: true,
        estado: 'expired',
        parametros: [],
        optimized: false,
        enabled: true,
    },
    '166391155611234': {
        nombre: 'Vendedora 7',
        patente: null,
        url_icono: '../icon/icon?tipo=dispositivo&scale=25&codigo=telefono2.png&color=ffffff&negative=0',
        url_imagen: '../icon/icon?tipo=dispositivo&scale=50&codigo=telefono2.png&color=ffffff&negative=0',
        id_deposito: '11260',
        id_deposito_fin: null,
        codigo_erp: null,
        agrupacion: null,
        id_dispositivo: '166391155611234',
        telefono: '5491155611234',
        chofer: '167336',
        expiracion_token: '2025-01-18 14:12:42',
        utilizacion_token: null,
        nombre_chofer: 'Vendedora 7',
        rateId: null,
        zonas: [],
        cortes: {
            Visitas: {
                id_maquina: '166391155611234',
                valor: 100,
                nombre: 'Visitas',
                url_icono: 'passenger.png',
                unidad: 'Visitas',
                prefijo: 'Visitas:',
                sufijo: 'u',
                carga: 0,
                nombreOriginal: 'Visitas',
            },
        },
        maxTime: 1440,
        maxDistance: 500,
        startTime: 480,
        minTime: 0,
        vueltaDeposito: 0,
        color: '#9F86C0',
        descarga: 0,
        token_expirado: true,
        estado: 'expired',
        parametros: [],
        optimized: false,
        enabled: true,
    },
};
